<template>
  <Section
    :id="id"
    :header="t('lineItems.lineItems', 2)"
    class="carrier-portal-line-item-section"
  >
    <Card class="carrier-portal-line-item-summary-card">
      <template #content>
        <div class="grid">
          <div class="col">
            <KeyValuePair
              :label="t('lineItems.lineItems', lineItems.length)"
              :value="n(lineItems.length, 'basic')"
              juicy
            />
          </div>
          <div
            class="col flex flex-column justify-content-evenly align-items-center"
          >
            <KeyValuePair
              :label="t('lineItems.handling')"
              :value="n(totalHandlingUnits, 'basic') + ' ' + handlingUnits"
              juicy
            />
          </div>
          <div
            class="col flex flex-column justify-content-evenly align-items-center"
          >
            <KeyValuePair
              :label="
                t('common.totalParam', {
                  param: t('lineItems.weight'),
                })
              "
              :value="
                translateNumberedEntity(
                  totalWeight,
                  'uoms.weight.abbreviations.POUND',
                )
              "
              juicy
            />
          </div>
        </div>
      </template>
    </Card>

    <div class="carrier-portal-line-items">
      <LineItemViewEdit
        v-for="(lineItem, index) in lineItems"
        :key="lineItem.id"
        :model-value="lineItem"
        :index="index"
        show-stops
      />
    </div>
  </Section>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { translateNumberedEntity } from '@rygen/rygen-ui/i18n';

import { useLineItemsSummary } from '@/composables';
import { ShipmentLineItem } from '@/model';

import LineItemViewEdit from '@/components/lineItem/LineItemViewEdit.vue';
import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';
import Card from 'primevue/card';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  lineItems: {
    type: Array as PropType<ShipmentLineItem[]>,
    default: () => [],
  },
});
const { id, lineItems } = toRefs(props);

const { n, t } = useI18n();
const { handlingUnits, totalHandlingUnits, totalWeight } =
  useLineItemsSummary(lineItems);
</script>

<style>
.carrier-portal-line-item-section {
  .carrier-portal-line-item-summary-card.p-card {
    margin-bottom: var(--sp-3);

    .p-card-body {
      padding: 0;

      .p-card-content {
        padding: 0;

        .grid {
          .col {
            padding: var(--p-card-body-padding);

            &:not(:last-of-type) {
              border-right: var(--divider);
            }

            .key-value-pair {
              .key-value-pair-label {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }

  .carrier-portal-line-items {
    .line-item-view-edit + .line-item-view-edit {
      margin-top: var(--sp-3);
    }
  }
}
</style>
